import { Button } from '../../Button/Button';
import { Text } from '../../Text/Text';
import { CommunicationMessage, Illustrations } from '../../Communication/CommunicationMessage';
import { ThemeMode, useProviderTheme } from '../../hooks/useProviderTheme';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface FeatureUnavailableProps {
  /**
   * Name of the unavailable feature.
   *
   * @type {string}
   * @memberof FeatureUnavailableProps
   */
  name: string;
  children?: React.ReactNode;
}

export const FeatureUnavailable: FC<FeatureUnavailableProps> = (props) => {
  const { t } = useTranslation();
  const { mode } = useProviderTheme();
  const emailAddress = 'support@aixconcept.de';
  const phoneNumber = '+49 2402-38941-99';
  return (
    <div className="flex flex-col items-center gap-4 mt-3">
      <CommunicationMessage
        headline={t('feature_not_available', { defaultValue: 'Feature nicht verfügbar' })}
        illustration={Illustrations.Hello}
        text={t('feature_not_available_message_format', {
          defaultValue:
            'Das Feature „{{feature}}“ ist in Ihrer Organisation nicht verfügbar. Sollte dies ein Fehler sein oder Sie haben Interesse an diesem Produkt, wenden Sie sich bitte telefonisch oder per E-Mail an unseren Support.',
          feature: props.name,
        })}
        useDarkIllustration={mode === ThemeMode.Dark}
      />
      <div className="flex flex-col items-center">
        <div className="flex items-center">
          <Text>{`${t('email', { defaultValue: 'E-Mail' })}:`}</Text>
          <Button appearance="transparent" onClick={() => window.open(`mailto:${emailAddress}`)}>
            {emailAddress}
          </Button>
        </div>
        <div className="flex items-center">
          <Text>{`${t('phone', { defaultValue: 'Telefon' })}:`}</Text>
          <Button appearance="transparent" onClick={() => window.open(`tel:${phoneNumber}`)}>
            {phoneNumber}
          </Button>
        </div>
      </div>
    </div>
  );
};

FeatureUnavailable.displayName = 'FeatureUnavailable';
